import AccountRequest from '@/shared/infrastructure/account/Request'
import CategoryRequest from '@/shared/infrastructure/categories/Request'

const actions = {
  contactUs(actions, payload) {
    return AccountRequest.contactUs(payload)
  },
  fetchFeaturedCategories() {
    return CategoryRequest.fetchFeaturedCategories()
  },
}

export default actions
